export default __webpack_public_path__ + "static/media/icon_like.96c10505.svg";